import BButton from 'components/common/BButton';
import useTranslation from 'next-translate/useTranslation';
import { FunctionComponent } from 'react';

interface DemandPaginationProps {
  totalPages: number;
  page: number;
  changePage: (val: number) => void;
}

const DemandPagination: FunctionComponent<DemandPaginationProps> = ({
  totalPages,
  page,
  changePage,
}) => {
  const { t } = useTranslation('common');
  return totalPages > 1 ? (
    <div className="flex items-center justify-end gap-2">
      <span className="mr-2 inline-block">{t('page')}</span>
      {[...Array(totalPages)].map((_, idx) => (
        <BButton
          key={idx}
          variant={page === idx ? 'primary' : 'secondary'}
          priority="text"
          className={page === idx ? 'underline' : ''}
          onClick={() => changePage(idx)}
        >
          {+idx + 1}
        </BButton>
      ))}
    </div>
  ) : null;
};

export default DemandPagination;
